module.exports = {
    init() {
        let $form = $("#ipValidateForm");
        if ($form.length == 0) return;

        const params = new Proxy(new URLSearchParams(window.location.search), {
            get: (searchParams, prop) => searchParams.get(prop),
        });
        let targetPage = params.source; //?source=blahblah

        if (!targetPage) return;

        var pwValue = $form.data('key');
        var cookieValue = "gT4!n8Y";
        if (this.getCookie("gated-access-key") == cookieValue) {
            window.location.replace(targetPage);
        }

        let $key = $form.find("#iprestrictedcode");
        if ($key.length == 0) return;

        $key.on("input", (e) => { e.target.setCustomValidity(''); });

        $form.show();

        $form.submit((e) => {
            e.preventDefault();

            if ($key.val() != pwValue) {
                $key.get(0).setCustomValidity('The code you entered was incorrect.');
                $key.get(0).reportValidity();
            }
            else {
                this.setCookie("gated-access-key", cookieValue, 30);
                window.location.replace(targetPage);
            }
        });
    },
    setCookie(name, value, days) {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/";
    },

    getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }
} 